import { Loader } from '@googlemaps/js-api-loader';
import { classes, selectors } from './init';

const loader = new Loader({
	apiKey: 'AIzaSyD4B6o-I6VE_lO9AMq4L6OFiHDckOKimfo',
	version: 'weekly',
});

let map, zoomLevel, infoWindow;

export const initMap = () => {
	loader.load().then(async () => {
		const { Map, InfoWindow } = await google.maps.importLibrary('maps');
		const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');

		// Iterate over all location elements that contain a map
		document.querySelectorAll(selectors.locationContainer).forEach((locationContainer) => {
			const mapContainer = locationContainer.querySelector(selectors.map);
			zoomLevel = mapContainer.getAttribute('data-focus') ? 15 : 14;

			// Initialize map
			map = new Map(mapContainer, {
				center: {
					lat: Number(mapContainer.getAttribute('data-center-lat')),
					lng: Number(mapContainer.getAttribute('data-center-lng')),
				},
				zoom: zoomLevel,
				zoomControl: true,
				streetViewControl: false,
				mapTypeControl: false,
				mapId: setMapID(),
			});

			// Initialize info window
			infoWindow = new InfoWindow();

			// Iterate over locations
			const locations = JSON.parse(mapContainer.getAttribute('data-locations'));

			if (document.querySelector(selectors.sidebar)) {
				// on click slide to location
				if (!document.querySelector(selectors.locationListMobile)) {
					document.querySelectorAll(`${selectors.locationList} .location__item`).forEach((location) => {
						location.addEventListener('click', () => {
							showLocationInMap(location.getAttribute('id'), zoomLevel);
						});
					});
				}
				setActiveClass(locations[0].id);
				showLocationInMap(locations[0].id, zoomLevel);
			}
			setMarker(locations, map, infoWindow, AdvancedMarkerElement);
		});
	});
};

const setMarker = (locations, map, infoWindow, AdvancedMarkerElement) => {
	locations.forEach((location) => {
		const markerProps = {
			map,
			position: { lat: parseFloat(location.lat), lng: parseFloat(location.lng) },
			title: location.title,
		};

		if (location.custom_marker_icon) {
			markerProps.content = getMarkerIcon(location.custom_marker_icon);
		}

		// Override marker icon if custom marker icon is set
		if (location.marker_icon) {
			markerProps.content = getMarkerIcon(location.marker_icon);
		}

		const marker = new AdvancedMarkerElement(markerProps);

		if (location.phone || location.website) {
			marker.addListener('click', () => {
				infoWindow.close();
				infoWindow.setContent(getContentHTML(location));
				infoWindow.open(marker.map, marker);
			});
		}
	});
};

const getContentHTML = (location) => {
	const phoneLabel = document.querySelector(selectors.map).getAttribute('data-phone-label');
	const websiteLabel = document.querySelector(selectors.map).getAttribute('data-website-label');

	const website = location.website ? `<p>${websiteLabel}: <a href="${location.website}" target="_blank">${location.website}</a></p>` : '';
	const email = location.email ? `<p>Mail: <a href="mailto:${location.email}">${location.email}</a></p>` : '';
	const phone = location.phone ? `<p>${phoneLabel}: <a href="tel:${location.phone}">${location.phone}</a></p>` : '';

	return `
		<div class="location__info-window">
			<h6>${location.title}</h6>
			${website}
			${email}
			${phone}
		</div>
	`;
};

const getMarkerIcon = (url) => {
	const markerIcon = document.createElement('span');
	// markerIcon.dataset.iconUrl = url;
	markerIcon.classList.add('marker-icon');
	markerIcon.style.setProperty('--mask-image', `url(${url})`);

	return markerIcon;
};

const setMapID = () => {
	const theme = document.documentElement.getAttribute('data-color-scheme');

	// get at least one of the data fields
	const dark = document.querySelector(selectors.map).getAttribute('data-map-id-dark');
	const light = document.querySelector(selectors.map).getAttribute('data-map-id-light');
	const backup = light || dark;

	if (theme === 'dark') {
		return dark ? dark : backup;
	} else {
		return light ? light : backup;
	}
};

const setActiveClass = (locationID) => {
	document.querySelectorAll(`${selectors.locationList} .location__item`).forEach((location) => {
		const tile = location.querySelector('.tile');
		tile.classList.remove(classes.active);
		if (location.getAttribute('id') === locationID) {
			location.firstChild.classList.add(classes.active);
		}
	});
};

export const showLocationInMap = (locationID, zoom) => {
	if (map) {
		const coordinates = JSON.parse(document.querySelector(selectors.map).getAttribute('data-locations')).find((location) => location.id === locationID);

		infoWindow.close();
		map.setCenter({ lat: parseFloat(coordinates.lat), lng: parseFloat(coordinates.lng) });
		map.setZoom(zoom);
	}
	setActiveClass(locationID);
};
